import { setEnvironment } from '../environment';

export const environment = {
  APPLICATION_NAME: 'Mixzen',
  API_BASE_URL: 'https://mixzen.agrifirm.com',
  CLIENT_ID: '8c830f86-9b7a-4d6b-a6bb-140b5ffcbd9b',
  REDIRECT_URL: 'https://mixzen.agrifirm.com',
  LOGIN_TYPE: 'redirect',
  SIGNUP_SIGNIN_POLICY: 'B2C_1A_EmployeeSignin',
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2c.b2clogin.com/tfp/agrifirmb2c.onmicrosoft.com/',
  APPLICATION_KEY: 'Mixzen',
  APP_INSIGHTS_KEY: '85cd43e7-c453-4fae-af0f-f11c73380889',
  DEFAULT_LOCALE: 'nl-NL',
  LOCALES: ['nl-NL', 'en-US'],
  PRODUCTION: true,
  RELATIONSHIPS_ELASTIC_SEARCH: true,
  CUSTOMER_IN_LOCATION_SELECTOR: false,
  POWER_BI_LINK_ENABLED: true,
  POWER_BI_URL:
    'https://app.powerbi.com/Redirect?action=OpenApp&appId=d3c3a058-1000-4b83-845d-b1fa0ff226ca&ctid=d819b495-b2a3-4cb7-99e7-f5b00a8e874f',
} as ReturnType<typeof setEnvironment>;
